import { useCallback, useEffect, useMemo } from 'react';
import type { ReactNode, MouseEvent } from 'react';

import Menu from '@mui/material/Menu';
import type { MenuProps } from '@mui/material/Menu';
import MenuItem from 'pages/company/WorkspaceRoute/components/DocumentContextMenu/components/MenuItem';

export type ContextMenuItem = {
  id: string;
  title: ReactNode;
  action?: () => void;
  disabled?: boolean;
  separator?: boolean;
  hidden?: boolean;
  submenu?: ContextMenuItem[];
  sx?: object;
};

type Props = {
  open: boolean;
  anchor?: Partial<MenuProps> | null;
  onClose: () => void;
  options: ContextMenuItem[];
  getDocumentLinkedCountByContextMenu?: () => void;
};

const MuiContextMenu = ({ open, anchor, onClose, options, getDocumentLinkedCountByContextMenu }: Props) => {
  const handleClick = useCallback(
    (event: MouseEvent, { action }: ContextMenuItem) => {
      event.stopPropagation();
      event.preventDefault();

      action?.();
      onClose();
    },
    [onClose],
  );

  const items = useMemo(() => options.filter((o) => !o.hidden), [options]);

  useEffect(() => {
    if (open) getDocumentLinkedCountByContextMenu?.();
  }, [getDocumentLinkedCountByContextMenu, open]);

  return (
    <Menu
      open={open}
      onClose={onClose}
      disableRestoreFocus
      slotProps={{ list: { disablePadding: true, autoFocus: true } }}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      {...(anchor || {})}
    >
      {items.map((entry) => (
        <MenuItem key={entry.id} entry={entry} onClick={handleClick} />
      ))}
    </Menu>
  );
};

export default MuiContextMenu;
